export default {
	methods: {
		buscarCabecalho() {
			return new Promise((resolve, reject) => {
				this.$http.get("api/folhaProducao/buscarCabecalho")
					.then((response) => {
						resolve(response.data);
					})
					.catch((err) => {
						reject(err);
					});
			});		
		},
		buscarItem(folhas) {
			return new Promise((resolve, reject) => {
				this.$http.get("api/folhaProducao/buscarItem/"+folhas)
					.then((response) => {
						resolve(response.data);
					})
					.catch((err) => {
						reject(err);
					});
			});		
		},
		buscarComposicao(folha) {
			return new Promise((resolve, reject) => {
				this.$http.get("api/folhaProducao/buscarComposicao/"+folha)
					.then((response) => {
						resolve(response.data);
					})
					.catch((err) => {
						reject(err);
					});
			});		
		},
		buscarDependente(sqfolha) {
			return new Promise((resolve, reject) => {
				this.$http.get("api/folhaProducao/buscarDependente/"+sqfolha)
					.then((response) => {
						resolve(response.data);
					})
					.catch((err) => {
						reject(err);
					});
			});		
		},
	}
}
